/**
 * Enum for SearchTypes
 */
const AlbumSearchTypeEnum = {
    // Download code
    DOWNLOADCODE: 0,
    // Regular Park
    REGULARPARK: 1,
    // Room
    ROOM: 2,
    // Video
    VIDEO: 3,
    // Dynamic Park
    DYNAMIC_PARK: 4
};

export default AlbumSearchTypeEnum;